import React, { useState, useRef, useEffect, useCallback } from 'react';
import { Menu } from 'lucide-react';
import UserInfo from './UserInfo';
import { useUser } from 'src/context/UserContext';
import './Header.scss';
import RoleSwitcher from "./RoleSwitcher";
import logo from 'src/images/pulse_logo.png';

const NAV_ITEMS = [
    { label: 'Announcements', id: 'announcements' },
    { label: 'Assigned Trainings', id: 'trainings' },
    { label: 'Calendar', id: 'calendar' },
    { label: 'Passdowns', id: 'passdowns' },
    { label: 'Recently Updated SOPs', id: 'sops' }
];

const Header = () => {
    const { canRead, isAdmin } = useUser();
    const canView = canRead('globalShiftPassdown') || canRead('alarmsShiftPassdown') || canRead('csShiftPassdown') || canRead('csirShiftPassdown') || canRead('cmShiftPassdown') || canRead('eventsShiftPassdown') || canRead('oimShiftPassdown');

    const [menuOpen, setMenuOpen] = useState(false);
    const menuRef = useRef<HTMLDivElement>(null);

    const navItems = NAV_ITEMS.filter(({ id }) => id !== 'passdowns' || canView);

    const closeMenu = useCallback((e: MouseEvent) => {
        if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
            setMenuOpen(false);
        }
    }, []);

    useEffect(() => {
        document.addEventListener('mousedown', closeMenu);
        return () => document.removeEventListener('mousedown', closeMenu);
    }, [closeMenu]);

    const handleNavClick = (id: string) => {
        document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
        setMenuOpen(false);
    };

    return (
        <header className="app-header">
            <div className="app-header__left">
                <img src={logo} className="app-header__logo" />
                <div className="app-header__menu" ref={menuRef}>
                    <button
                        type="button"
                        className="app-header__menu-btn"
                        aria-label="Menu"
                        aria-haspopup="true"
                        aria-expanded={menuOpen}
                        onClick={() => setMenuOpen(prev => !prev)}
                    >
                        <Menu size={22} color="currentColor" />
                    </button>
                    {menuOpen && (
                        <div className="app-header__dropdown" role="menu">
                            {navItems.map(({ id, label }) => (
                                <button
                                    key={id}
                                    type="button"
                                    role="menuitem"
                                    className="app-header__dropdown-item"
                                    onClick={() => handleNavClick(id)}
                                >
                                    {label}
                                </button>
                            ))}
                        </div>
                    )}
                </div>
            </div>
            <div className="app-header__right">
                {isAdmin && <RoleSwitcher />}
                <UserInfo />
            </div>
        </header>
    );
};

export default Header;
